"use client"

import { enemyTypes } from "@/data/enemy-types"
import { EnemyThumbnail } from "./enemy-thumbnail"
import { EnemyDetails } from "./enemy-details"

interface EnemiesCodexContentProps {
  selectedEnemyId: string | null
  onSelectEnemy: (enemyId: string | null) => void
  isEntityUnlocked: (entityId: string) => boolean
}

// Order of enemies to display (by level/difficulty)
const ENEMY_ORDER = [
  "rat",
  "goblin",
  "mushroom",
  "lizardman",
  "zombie",
  "skeleton",
  "orc",
  "ghost",
  "gnoll",
  "golem",
  "lich",
  "vampire",
  "imp",
  "ent",
  "beholder",
  "demon",
]

export const EnemiesCodexContent = ({
  selectedEnemyId,
  onSelectEnemy,
  isEntityUnlocked,
}: EnemiesCodexContentProps) => {
  // Thumbnails content
  const thumbnailsContent = (
    <>
      {ENEMY_ORDER.map((enemyId) => {
        const enemy = enemyTypes[enemyId]
        if (!enemy) return null

        const isLocked = !isEntityUnlocked(enemyId)
        const isSelected = selectedEnemyId === enemyId

        return (
          <EnemyThumbnail
            key={enemyId}
            enemyId={enemyId}
            enemyName={enemy.name}
            isSelected={isSelected}
            isLocked={isLocked}
            onClick={() => {
              if (!isLocked) {
                onSelectEnemy(isSelected ? null : enemyId)
              }
            }}
          />
        )
      })}
    </>
  )

  // Details content
  const detailsContent = selectedEnemyId ? (
    <EnemyDetails enemy={enemyTypes[selectedEnemyId]} />
  ) : null

  const present = ENEMY_ORDER.filter((id) => enemyTypes[id])

  return {
    thumbnailsContent,
    detailsContent,
    hasSelection: selectedEnemyId !== null,
    total: present.length,
    discovered: present.filter((id) => isEntityUnlocked(id)).length,
  }
}
